import { twMerge } from "tailwind-merge";
import { X } from "lucide-react";
import type { Article, Category } from "@core/features/support";
import { Button } from "@themes/pollinator/ui/Button";
import { Type } from "@themes/pollinator/ui/Type";
import { SupportCategoryTree } from "@platform/features/support";

export type Props = {
  article?: Article;
  className?: string;
  categories: Category[];
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onNavigationClick: (article: Article) => void;
};

export function SupportCategoryAccordion({
  article,
  className,
  categories,
  onNavigationClick,
  isOpen,
  setIsOpen,
}: Props) {
  return (
    <div
      className={twMerge(
        "transition-all duration-300 ease-in-out",
        isOpen ? "h-[300px]" : "h-0 overflow-hidden",
        className
      )}
    >
      <div className="flex items-center justify-between p-4 border-b">
        <Type as="h4" variant="h6">
          Categories
        </Type>
        <Button
          variant="ghost"
          onClick={() => setIsOpen(!isOpen)}
          iconComponent={X}
          data-testid="support-categories-close"
        >
          Close Categories
        </Button>
      </div>
      <div className="p-4 h-[calc(300px-4rem)] overflow-y-auto">
        <SupportCategoryTree
          categories={categories}
          activeArticleId={article?.id}
          onArticleClick={onNavigationClick}
        />
      </div>
    </div>
  );
}

export default SupportCategoryAccordion;

